import 'globals/outside';

import AdditionalMaterialsView from 'backbone/settings/views/publication/additional_materials_view.js';

import Page from 'lib/page.js';
Page.init({ AdditionalMaterialsView });



// WEBPACK FOOTER //
// ./app/javascript/packs/content_requests.js